import { render, staticRenderFns } from "./MindMap.vue?vue&type=template&id=499f4734&scoped=true"
import script from "./MindMap.vue?vue&type=script&lang=ts"
export * from "./MindMap.vue?vue&type=script&lang=ts"
import style0 from "./MindMap.vue?vue&type=style&index=0&id=499f4734&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499f4734",
  null
  
)

export default component.exports